import React, { Fragment } from "react";
import { connect } from "react-redux";
import ShowTask from "../components/ShowTask";
import { requestTask, resetTask } from "../actions/taskAction";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";

class TaskContainer extends React.Component {
  componentDidMount() {
    this.props.requestTask(this.props.match.params.id);
  }

  componentWillUnmount() {
    this.props.resetTask();
  }

  render() {
    const { loading, task } = this.props;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            mountOnEnter
            unmountOnExit
            id="left-tabs-example"
            activeKey="show"
          >
            <div className="container-fluid pt-5">
              <Tab.Content>
                <Tab.Pane eventKey="show">
                  <ShowTask
                    task={task}
                    history={this.props.history}
                    updateTask={this.props.requestTask}
                  />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  task: state.requestTask.task,
  loading: state.requestTask.loading,
});
const mapDispatchToProps = (dispatch) => ({
  requestTask: (taskId) => dispatch(requestTask(taskId)),
  resetTask: () => dispatch(resetTask()),
});
export default connect(mapStateToProps, mapDispatchToProps)(TaskContainer);
